import { ActionReducerMapBuilder, Dispatch, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/dist/tsHelpers';

import { BebyggelseobjektPublicerad, ModelError, State } from 'models';

import type { RootState } from './rootReducer';
import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from './storeHelpers';

import BebyggelseApi from 'api/bebyggelseApi';

export const getBebyggelseobjekt = createAsyncThunk<BebyggelseobjektPublicerad, string, { rejectValue: ModelError }>(
  'get/bebyggelseobjekt',
  async (id: string, { rejectWithValue }): Promise<any> => {
    const response = await BebyggelseApi.bebyggelseobjekt.get(id);
    return errorOr<BebyggelseobjektPublicerad>(response, rejectWithValue);
  },
  {
    condition: (_id: string, { getState }): false | undefined => requestCondition(getState)
  }
);

const requestCondition = (getState: () => unknown): false | undefined => {
  const { bebyggelseobjekt } = getState() as RootState;
  if (bebyggelseobjekt.requestStatus === 'pending') return false;
};

export const clearBebyggelseobjekt = () => {
  return (dispatch: Dispatch) => {
    dispatch(clearBebyggelseobjektState());
  };
};

const initialState: State<BebyggelseobjektPublicerad> = {
  requestStatus: 'idle',
  requestType: undefined,
  data: undefined,
  currentRequestId: undefined,
  error: undefined
};

const bebyggelseobjektPubliceradSlice = createSlice({
  name: 'bebyggelseobjekt',
  initialState,
  reducers: {
    clearBebyggelseobjektState: (state: Draft<State<BebyggelseobjektPublicerad>>): void => {
      state.data = undefined;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<BebyggelseobjektPublicerad>>>): void => {
    builder.addCase(
      getBebyggelseobjekt.pending,
      (state: Draft<State<BebyggelseobjektPublicerad>>, action: PendingActionType): void => pending(state, action)
    );
    builder.addCase(
      getBebyggelseobjekt.fulfilled,
      (
        state: Draft<State<BebyggelseobjektPublicerad>>,
        action: FulfilledActionType<BebyggelseobjektPublicerad>
      ): void => fulfilled(state, action)
    );
    builder.addCase(
      getBebyggelseobjekt.rejected,
      (state: Draft<State<BebyggelseobjektPublicerad>>, action: RejectedActionType): void => rejected(state, action)
    );
  }
});
export const { clearBebyggelseobjektState } = bebyggelseobjektPubliceradSlice.actions;

export default bebyggelseobjektPubliceradSlice.reducer;
